import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Global error handling + perf monitoring
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    console.error('[Sintech Global Error]', event.error || event.message, event.filename, event.lineno);
  });
  window.addEventListener('unhandledrejection', (event) => {
    console.error('[Sintech Unhandled Rejection]', event.reason);
  });
}

// Perf monitoring - logs CLS/FID/FCP/LCP/TTFB to console
reportWebVitals((metric) => {
  console.log(metric.name, (metric.value * 1000).toFixed(0));
});
